const feathers = require('@feathersjs/client');
const rest = feathers.rest;
const axios = require('axios');

const app = feathers();

// Connect to the same as the browser URL (only in the browser)
const restClient = rest();

// Configure an AJAX library (see below) with that client 
app.configure(restClient.axios(axios));
console.log("Client connected.")
// Connect to the `http://feathers-api.com/messages` service
export default app
